import classic from './classic';
import compact from './compact';
import elegance from './elegance';
import {
  jsonElegant,
  jsonFlat,
  jsonExecutiveSlate,
  jsonModernClassic,
  jsonStackoverflow,
} from './json-resume';
import moderne from './moderne';
import { registerTemplate } from './registry';

export function registerAllTemplates() {
  registerTemplate(classic);
  registerTemplate(moderne);
  registerTemplate(elegance);
  registerTemplate(compact);
  registerTemplate(jsonElegant);
  registerTemplate(jsonFlat);
  registerTemplate(jsonExecutiveSlate);
  registerTemplate(jsonModernClassic);
  registerTemplate(jsonStackoverflow);
}
